<template lang="pug">
.home-container(
    :style='{ backgroundImage: "url(" + require("@/assets/imgs/房屋.png") + ")" }'
)
    .top(v-html) 圣戈班<br>高新材料
    .text 用材料改变生活
    .bar
    .list-container
        img.l1.l(
            v-src='\'https://oss.cloud.custouch.com/res/21683/市场应用2.png\'',
            @click='jump("market", ".l1")'
        )
        img.l2.l(
            v-src='\'https://oss.cloud.custouch.com/res/21684/产品介绍2.png\'',
            @click='jump("introduce", ".l2")'
        )
        img.l3.l(
            v-src='\'https://oss.cloud.custouch.com/res/91014/直播看点.png\'',
            @click='jump("class", ".l3")'
        )
        img.l66.l(
            v-src='\'https://oss.cloud.custouch.com/res/35725/联系我们.png\'',
            @click='jump("contact", ".l66")'
        )
        img.l4.l(
            v-src='\'https://oss.cloud.custouch.com/res/21686/资料下载2.png\'',
            @click='jump("download", ".l4")'
        )
        img.l5.l(
            v-src="'https://oss.cloud.custouch.com/res/56260/百宝箱.png'",
            @click='jump("utils", ".l5")'
        )
        img.l5-1.l(
            v-src='\'https://oss.cloud.custouch.com/res/21685/关于我们2.png\'',
            @click='jump("about", ".l5-1")'
        )
        img.l6.ll(src='@/assets/imgs/1.png')
        img.l7.ll(src='@/assets/imgs/2.png')
        img.l8.ll(src='@/assets/imgs/3.png')
        img.l9.ll(src='@/assets/imgs/4.png')
        img.l10.ll(src='@/assets/imgs/5.png')
        img.l11.ll(src='@/assets/imgs/6.png')
        img.l12.ll(src='@/assets/imgs/7.png')
</template>

<script>
import anime from 'animejs'
export default {
    name: 'home',
    components: {},
    created() {
        this.$root.$emit('updateShare', { title: document.title })
    },
    methods: {
        fn() {},
        jump(name, target) {
            anime({
                targets: target,
                scale: 1.3,
                easing: 'easeInOutCirc',
                complete: () => {
                    this.$router.push({ name })
                },
            })
        },
    },
    mounted() {
        const t1 = anime({
            duration: 750,
            easing: 'spring(1, 80, 12, 0)',
            delay: anime.stagger(150),
            opacity: [0, 1],
            targets: ['.l'],
            scale: [0, 1],
            translateX: [500, 0],
        })
    },
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin.less';
.home-container {
    // flex:1;
    // background:red!important;
    .fuzhu {
        width: 100%;
        position: absolute;
        top: 13.5rem;
        left: 0.4rem;
    }
    position: relative;
    background-repeat: no-repeat;
    background-size: 160%;
    background-position: -4.9rem 2.5rem;
    .top {
        font-weight: 700;
        margin-top: 1.35rem;
        margin-left: 1.05rem;
        color: #219cdc;
        font-size: 1.5rem;
        line-height: 2.1rem;
        margin-bottom: 0.55rem;
        margin: 1.35rem 0rem 0.55rem 1.05rem;
        font-weight: 500;
        letter-spacing: 0.1rem;
    }
    .text {
        margin-left: 1.05rem;
        margin-bottom: 0.55rem;
        font-size: 0.7rem;
        line-height: 1rem;
        letter-spacing: 0.05rem;
        color: #219cdc;
    }

    .list-container {
        background: red !important;

        .ll {
            position: absolute;
            z-index: 99;
        }
        .l6 {
            width: 4.1rem;
            height: 4.1rem;
            left: 0rem;
            top: 19.5rem;
        }
        .l7 {
            width: 5.66rem;
            height: 5.66rem;
            left: 2.7rem;
            top: 13.2rem;
        }
        .l8 {
            width: 4.38rem;
            height: 4.38rem;
            left: 2.67rem;
            top: 23rem;
        }
        .l9 {
            width: 3.96rem;
            height: 3.96rem;
            top: 19.6rem;
            left: 5.84rem;
        }
        .l10 {
            width: 3.96rem;
            height: 3.96rem;
            top: 20.6rem;
            left: 9.84rem;
        }
        .l11 {
            width: 3.96rem;
            height: 3.96rem;
            left: 15.94rem;
            top: 14rem;
        }
        .l12 {
            width: 3.38rem;
            height: 3.38rem;
            left: 15.64rem;
            top: 24rem;
        }
        .l {
            position: absolute;
            z-index: 999;
        }
        .l1 {
            width: 7.2rem;
            height: 7.2rem;
            left: 5.72rem;
            top: 10.02rem;
            // left:35.9%;
            // top:36.9%;
        }
        .l2 {
            width: 7.2rem;
            height: 7.2rem;
            left: 1.32rem;
            top: 14.07rem;
        }
        .l3 {
            width: 6.59rem;
            height: 6.59rem;
            left: 9.95rem;
            top: 14.75rem;
        }
        .l4 {
            // left:32.8%;
            left: 5.35rem;
            width: 6.59rem;
            height: 6.59rem;
            top: 18.15rem;
            // top:66.85%;
        }
        .l5 {
            width: 5.74rem;
            height: 5.74rem;
            // left:66.29%;
            // top:73.04%
            left: 12.43rem;
            top: 20.23rem;
        }
        .l5-1 {
            width: 5.74rem;
            height: 5.74rem;
            left: 8.43rem;
            top: 23.63rem;
        }
        .l66 {
            width: 5.74rem;
            height: 5.74rem;
            left: 0.43rem;
            top: 20.63rem;
        }
    }
    .bar {
        margin-left: 1.05rem;
        width: 1.6rem;
        height: 0.25rem;
        background: #219cdc;
    }
}
</style>
